module.exports = __webpack_public_path__ + "static/media/000_gls_leg_l.fdd9d5f1.png";